
<template>
  <div>
    <v-row class="px-3" align="baseline">
      <v-subheader>Criar plano de ação quando inconforme?</v-subheader> <small>Plano de ação criado no momento da execução </small>
    </v-row>
    <v-sheet class="ml-2" max-width="1000" >
      <v-slide-group mandatory v-model="newItem.action_plan_enabled" center-active>
        <v-slide-item :value="kind.kind" v-for="(kind,idx) in allPlans" :key="'ckind7'+idx" v-slot:default="{ active, toggle }">
          <v-btn class="mx-2" depressed rounded :input-value="active" @click="toggle" 
            active-class="secondary darken-1 white--text"
          >
            <v-icon left>{{kind.icon}}</v-icon>{{kind.name}}
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>


    <!-- nao mostrar até definir qual eh o melhor metodo de usar o action_plan_kind no done_item, para ser continuado -->
    <v-row class="ml-3" align="center" v-if="false && newItem.action_plan_enabled">
      <v-subheader>Modelo: </v-subheader>
      <v-radio-group v-model="newItem.action_plan_kind" mandatory row>
        <v-radio value="5w2h">
          <template v-slot:label>
            <div><strong class="success--text">5W2H</strong></div>
          </template>
        </v-radio>
        <v-radio value="simple">
          <template v-slot:label>
            <div><strong class="primary--text">Simples</strong></div>
          </template>
        </v-radio>
      </v-radio-group>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      allPlans: [
        {name: 'Não', kind: false, icon:'mdi-close'},
        {name: 'Sim', kind: true, icon:'mdi-check'},
      ],
      newItem: this.$attrs.newItem,
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>